export default "__VITE_ASSET__BnPR5KVA__"